"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FooterSimple = function FooterSimple(_ref) {
  var title = _ref.title,
      links = _ref.links,
      variant = _ref.variant,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "links", "variant"]);

  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    sx: {
      alignItems: ['center', 'center', 'flex-start'],
      flexDirection: 'column',
      p: 5
    }
  }), (0, _themeUi.jsx)(_Text["default"], {
    variant: "subtitle",
    sx: {
      color: variant === 'light' ? 'textWhite' : 'text'
    }
  }, title), links && (0, _themeUi.jsx)(_Text["default"], {
    variant: "caption",
    sx: {
      color: variant === 'light' ? 'textWhite' : 'text',
      display: 'block'
    }
  }, links && links.map(function (link) {
    return (0, _themeUi.jsx)("a", {
      key: link.label,
      href: link.url,
      sx: {
        mr: 2,
        textDecoration: 'underline',
        color: 'inherit'
      }
    }, link.label);
  })));
};

FooterSimple.propTypes = {
  title: _propTypes["default"].string,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    url: _propTypes["default"].string
  })),
  variant: _propTypes["default"].oneOf(['light', 'dark'])
};
FooterSimple.defaultProps = {
  title: null,
  links: null,
  variant: 'light'
};
var _default = FooterSimple;
exports["default"] = _default;